module.exports = __webpack_public_path__ + "img/workTable.b4b503b4.png";